<template>
  <div class="blog-card">
    <div class="blog-card-image-container">
      <img :src="blog.image || '/placeholder.jpg'" :alt="blog.title" class="blog-card-image" />
    </div>
    <div class="blog-card-body">
      <div class="blog-card-meta">
        <i class="fa fa-calendar"></i>
        <span style="margin-left: 5px;">{{ formatDate(blog.created_at) }}</span>
        <span class="dot">•</span>
        <span class="blog-card-category">{{ blog.category || 'General' }}</span>
        <span v-if="blog.author" class="dot">•</span>
        <span v-if="blog.author" class="blog-card-author">{{ blog.author }}</span>
      </div>
      <router-link :to="`/blog/${blog.slug}`" class="blog-card-title">{{ blog.title }}</router-link>
      <p class="blog-card-desc">
        {{ blog.meta_description || (blog.content ? blog.content.slice(0, 120) + '...' : blog.summary) }}
      </p>
      <div class="blog-card-tags" v-if="blog.tags && blog.tags.length > 0">
        <span v-for="tag in blog.tags.slice(0, 3)" :key="tag" class="blog-tag">
          #{{ tag }}
        </span>
      </div>
      <router-link :to="`/blog/${blog.slug}`" class="orange-btn">
        Read more <span class="arrow">→</span>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
})

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}
</script>

<style scoped>
.blog-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(44, 62, 80, 0.10);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.2s;
}

.blog-card:hover {
  box-shadow: 0 8px 32px rgba(44, 62, 80, 0.16);
}

.blog-card-image-container {
  height: 192px;
  overflow: hidden;
}

.blog-card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s;
}

.blog-card-image:hover {
  transform: scale(1.05);
}

.blog-card-body {
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 180px;
}

.blog-card-meta {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.blog-card-meta .dot {
  margin: 0 8px;
}

.blog-card-category {
  background: #e0e7ff;
  color: #1e40af;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 6px;
  margin-left: 8px;
}

.blog-card-author {
  color: #6b7280;
  font-size: 12px;
  font-style: italic;
}

.blog-card-title {
  font-size: 20px;
  font-weight: bold;
  color: #111827;
  margin-bottom: 12px;
  transition: color 0.2s;
  text-decoration: none;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 48px;
  line-height: 24px;
}

.blog-card-title:hover {
  color: #2563eb;
}

.blog-card-desc {
  color: #4b5563;
  margin-bottom: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 60px;
  line-height: 20px;
}

.blog-card-tags {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.blog-tag {
  background: #f3f4f6;
  color: #6b7280;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
}

.blog-card-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: auto;
}

.blog-card-btn:hover {
  background: #1e40af;
  color: #fff;
  text-decoration: none;
}

.blog-card-btn .arrow {
  margin-left: 6px;
  font-size: 1.1em;
}

@media (max-width: 768px) {
  .blog-card-meta {
    font-size: 12px;
  }
  
  .blog-card-title {
    font-size: 18px;
  }
  
  .blog-card-desc {
    font-size: 14px;
  }
}
</style>